module.exports = __webpack_public_path__ + "img/Widgets.d7f3a8f0.gif";